import * as ActionTypes from './index';

export function sortBrokers(payload) {
    return {
        type: ActionTypes.SORT_BROKERS,
        payload: payload
    }
}

export function getBrokersSuggestions(payload) {
    return {
        type: ActionTypes.GET_BROKERS_SUGGESTIONS,
        payload: payload
    }
}

export function getBrokersSuggestionsSuccess(payload) {
    return {
        type: ActionTypes.GET_BROKERS_SUGGESTIONS_SUCCESS,
        payload: payload
    }
}

export function getBrokersSuggestionsFailed(payload) {
    return {
        type: ActionTypes.GET_BROKERS_SUGGESTIONS_FAILED,
        payload: payload
    }
}

export function changeBrokersListPage(payload) {
    return {
        type: ActionTypes.CHANGE_BROKERS_LIST_PAGE,
        payload: payload
    }
}

export function brokersListPageShift(payload) {
    return {
        type: ActionTypes.BROKERS_LIST_PAGE_SHIFT,
        payload: payload
    }
}

export function changeBrokersState(payload) {
    return {
        type: ActionTypes.CHANGE_BROKERS_STATE,
        payload: payload
    }
}

export function getBrokers(payload) {
    return {
        type: ActionTypes.GET_BROKERS,
        payload: payload
    }
}

export function getBrokersSuccess(payload) {
    return {
        type: ActionTypes.GET_BROKERS_SUCCESS,
        payload: payload
    }
}

export function getBrokersFailed(payload) {
    return {
        type: ActionTypes.GET_BROKERS_FAILED,
        payload: payload
    }
}